import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from '@mui/material';

const TopBar = ({ disableDashboardLink }) => {
  return (
    <header className="top-bar">
      <div className="top-bar-left">
        {/* Placeholder for logo */}
        <div className="logo">a1facts</div>
      </div>
      <nav className="top-bar-right">
        {disableDashboardLink ? (
          <span className="nav-link disabled">Dashboard</span>
        ) : (
          <Link to="/dashboard" className="nav-link">Dashboard</Link>
        )}
        <Link to="/playground" className="nav-link">Playground</Link>
        <Link to="/docs" className="nav-link">Docs</Link>
        <Avatar />
      </nav>
    </header>
  );
};

export default TopBar;
